<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div v-show="$route.path == '/Report/PaymentProduct'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reStartDate"
                      name="reStartDate" ref="reStartDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                  <span class="form-text" style="color: #fd397a;" v-for="error in errors"
                    v-if="error.name == 'reStartDate'">{{ error.text }}</span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input readonly type="text" class="form-control" placeholder="(วว/ดด/ปปปป)" id="reEndDate"
                      name="reEndDate" ref="reEndDate" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                  <span class="form-text" style="color: #fd397a;" v-for="error in errors"
                    v-if="error.name == 'reEndDate'">{{ error.text }}</span>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">BARCODE:</label>
                  <input id="reBarcode" v-model="reBarcode" type="text" class="form-control"
                    placeholder="กรุณาระบุรหัส BARCODE (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <treeselect id="reProductTypeId" v-model="reProductTypeId" :multiple="true" :options="reProductTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="reProductCode" v-model="reProductCode" :multiple="true" :options="reProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <treeselect id="reProductBrandId" v-model="reProductBrandId" :multiple="true" :options="reProductBrandIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>มุมมองผู้ใช้งาน:</label>
                  <treeselect id="reViewPermissionCode" v-model="reViewPermissionCode" :multiple="false" :options="reViewPermissionOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" @input="ChangeOptions('View')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>ชื่อคลังสินค้า:</label>
                  <treeselect id="rePlantCode" v-model="rePlantCode" :multiple="true" :options="rePlantCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'AGENT_REPORT'">
                <div class="form-group">
                  <label>ชื่อตัวแทนจำหน่าย:</label>
                  <treeselect id="reAgentCode" v-model="reAgentCode" :multiple="true" :options="reAgentCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" @input="ChangeOptions('reAgentCode')" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
                v-if="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  <treeselect id="reSubAgentCode" v-model="reSubAgentCode" :multiple="true" :options="reSubAgentCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" @input="ChangeOptions('reSubAgentCode')" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ร้านค้า:</label>
                  <treeselect id="reShopCode" v-model="reShopCode" :multiple="true" :load-options="LoadreShopCodeOptions" :async="true"
                    :cacheOptions="false" searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา" placeholder="กรุณาเลือก"
                    v-on:open="resLoadreShopCodeOptions" ref="reShopCode" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect v-model="reShopTypeId" :multiple="true" :options="reShopTypeIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <treeselect id="reSalesAreaId" v-model="reSalesAreaId" :multiple="true" :options="reSalesAreaIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" :id="'reSalesAreaId'" :name="'reSalesAreaId'"
                    ref="reSalesAreaId" @input="ChangeOptions('reSalesAreaId')" />
                  <!-- <span class="form-text" style="color: #fd397a;" v-for="error in errors"
                    v-if="error.name == 'reSalesAreaId'">{{ error.text
                    }}</span> -->
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <treeselect id="reProvinceId" v-model="reProvinceId" :multiple="true" :options="reProvinceIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" :id="'reProvinceId'" :name="'reProvinceId'"
                    ref="reProvinceId" />
                  <!-- <span class="form-text" style="color: #fd397a;" v-for="error in errors"
                    v-if="error.name == 'reProvinceId'">{{ error.text
                    }}</span> -->
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>ขนส่ง:</label>
                  <treeselect id="reTransitId" v-model="reTransitId" :multiple="true" :options="reTransitIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="reViewPermissionCode == 'BR_REPORT'">
                <div class="form-group">
                  <label>สังกัด(ขนส่ง):</label>
                  <treeselect id="reTransitType" v-model="reTransitType" :multiple="true" :options="reTransitTypeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผู้ดำเนินการ:</label>
                  <!-- <treeselect id="reScanUserId" v-model="reScanUserId" :multiple="true" :options="reScanUserIdOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" /> -->
                  <treeselect id="reScanUserId"
                      v-model="reScanUserId"
                      :multiple="true"
                      :load-options="LoadreScanUserIdOptions"
                      v-on:open="reLoadreScanUserIdOptions"
                      :async="true"
                      :clear-on-select="true"
                      placeholder="กรุณาเลือก"
                      :cacheOptions="true"
                      ref="reScanUserId"
                    />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportPaymentProduct($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="PaymentProductTable" style="width:100%">
                <thead>
                  <tr>
                    <th class="all text-right" colspan="19">
                      ข้อมูล ณ วันที่ {{ reDateReq }}
                    </th>
                  </tr>

                  <tr v-if="reViewPermissionCode == 'AGENT_REPORT'">
                    <th class="all text-center"></th>
                    <th class="all text-center"></th>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">ผู้ดำเนินการ</th>
                  </tr>

                  <tr v-if="reViewPermissionCode == 'SUB_AGENT_REPORT'">
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">ผู้ดำเนินการ</th>
                  </tr>

                  <tr v-if="reViewPermissionCode == 'BR_REPORT'">
                    <th class="all text-center"></th>
                    <th class="all text-center"></th>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">รหัสคลังสินค้า</th>
                    <th class="all text-center">ชื่อคลังสินค้า</th>
                    <th class="all text-center">เลขที่ใบงาน</th>
                    <th class="all text-center">ขนส่ง</th>
                    <th class="all text-center">สังกัด(ขนส่ง)</th>
                    <th class="all text-center">รหัสตัวแทนจำหน่าย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">รหัสสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">BARCODE</th>
                    <th class="all text-center">จำนวน</th>
                    <th class="all text-center">วันที่</th>
                    <th class="all text-center">ผู้ดำเนินการ</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th class="text-center" colspan="14"></th>
                    <th class="text-center">จำนวนรวม</th>
                    <th class="text-center">{{ reTotalBarcode }}</th>
                    <th class="text-center" colspan="2"></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function () {
    var self = this;

    return {
      LoadFrist: true,
      errors: [],
      columns: null,
      reOrderBy: null,
      reViewPermissionCode: null,
      reViewPermissionOptions: [],
      reDateReq: null,
      reIsInitial: true,
      reDateCycle: null,
      reStartDate: null,
      reEndDate: null,
      reBarcode: null,
      reProductTypeId: [],
      reProductTypeIdOptions: [],
      reProductCode: [],
      reProductCodeOptions: [],
      reProductBrandId: [],
      reProductBrandIdOptions: [],
      rePlantCode: [],
      rePlantCodeOptions: [],
      reAgentCode: [],
      reAgentCodeOptions: [],
      reSubAgentCode: [],
      reSubAgentCodeOptions: [],
      reShopCode: [],
      reShopCodeOptions: [],
      // reSaShopNameOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกร้านค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2ShopQuery",
      //     data: function(params) {
      //       var query = {
      //         agentCode: self.reSaAgentCode,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reShopTypeId: [],
      reShopTypeIdOptions: [],
      reSalesAreaId: [],
      reSalesAreaIdOptions: [],
      reProvinceId: [],
      reProvinceIdOptions: [],
      reTransitId: [],
      reTransitIdOptions: [],
      reTransitType: [],
      reTransitTypeOptions: [],
      reScanUserId: [],
      reScanUserIdOptions: [],
      reTotalBarcode: 0,
      isLoadingOptions: true,
    };
  },
  computed: {},
  methods: {
    formReset: function (e) {
      let self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reSubAgentCode = [];
      self.reShopCode = [];
      self.reSalesAreaId = [];
      self.reProvinceId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reSubAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reSalesAreaId").val("").trigger("change");
      $("#reProvinceId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formResetValue: function (e) {
      let self = this;

      self.reStartDate = null;
      self.reEndDate = null;
      self.reBarcode = null;
      self.reProductTypeId = [];
      self.reProductCode = [];
      self.reProductBrandId = [];
      self.rePlantCode = [];
      self.reAgentCode = [];
      self.reSubAgentCode = [];
      self.reShopCode = [];
      self.reSalesAreaId = [];
      self.reProvinceId = [];
      self.reTransitId = [];
      self.reTransitType = [];
      self.reScanUserId = [];

      $("#reStartDate").val("").trigger("change");
      $("#reEndDate").val("").trigger("change");
      $("#reBarcode").val("").trigger("change");
      $("#reProductTypeId").val("").trigger("change");
      $("#reProductCode").val("").trigger("change");
      $("#reProductBrandId").val("").trigger("change");
      $("#rePlantCode").val("").trigger("change");
      $("#reAgentCode").val("").trigger("change");
      $("#reSubAgentCode").val("").trigger("change");
      $("#reShopCode").val("").trigger("change");
      $("#reSalesAreaId").val("").trigger("change");
      $("#reProvinceId").val("").trigger("change");
      $("#reTransitId").val("").trigger("change");
      $("#reTransitType").val("").trigger("change");
      $("#reScanUserId").val("").trigger("change");

      //this.formSubmit(e, "ล้างค่าทั้งหมด");
    },
    formSubmit: async function (e, innerText = null) {
      let self = this;
      var IsValidate = true;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reIsInitial = true;
      }
      else {
        self.errors = [];

        // if (!self.reSalesAreaId || self.reSalesAreaId == undefined || self.reSalesAreaId == null || self.reSalesAreaId.length == 0) {
        //   self.errors.push({ name: 'reSalesAreaId', text: 'กรุณาเลือกเขต' });
        //   IsValidate = false;
        // }

        // if (!self.reProvinceId || self.reProvinceId == undefined || self.reProvinceId == null || self.reProvinceId.length == 0) {
        //   self.errors.push({ name: 'reProvinceId', text: 'กรุณาเลือกจังหวัด' });
        //   IsValidate = false;
        // }

        if (!self.reStartDate || self.reStartDate == undefined || self.reStartDate == null) {
          self.errors.push({ name: 'reStartDate', text: 'กรุณาเลือกวันที่เริ่มต้น' });
          IsValidate = false;
        }

        if (!self.reEndDate || self.reEndDate == undefined || self.reEndDate == null) {
          self.errors.push({ name: 'reEndDate', text: 'กรุณาเลือกวันที่สิ้นสุด' });
          IsValidate = false;
        }
        // if (!$(this.$refs.form).validate().form()) {
        //   return false;
        // }
      }

      if (IsValidate == true) {
        e.preventDefault();
        var table = $("#PaymentProductTable").DataTable();
        await self.GenCollums(table, "submit");
        // table.draw();
      }
      else {
        return IsValidate;
      }
    },
    LoadrePlantCodeOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          all: true,
          page: 1,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.rePlantCodeOptions = [];
            data.forEach((element) => {
              self.rePlantCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductTypeIdOptions = [];
            data.forEach((element) => {
              self.reProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductCodeOptions = [];
            data.forEach((element) => {
              self.reProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProductBrandIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2ProductBrand", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProductBrandIdOptions = [];
            data.forEach((element) => {
              self.reProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreAgentCodeOptions: function (e) {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2AgentPaymentProduct", {
          SalesAreaId: self.reSalesAreaId,
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reAgentCodeOptions = [];
            data.forEach((element) => {
              self.reAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreSubAgentCodeOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Report/Select2SubAgent", {
          SalesAreaId: self.reSalesAreaId,
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reSubAgentCodeOptions = [];
            data.forEach((element) => {
              self.reSubAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreShopCodeOptions: _.debounce(function ({ action, searchQuery, callback }) {
      //this.$emit('activate', this.item)
      var self = this;
      if (action === "ASYNC_SEARCH") {
        axios
          .post("/Api/Report/Select2ShopAgent", {
            Page: 1,
            All: true,
            Search: searchQuery,
            InActiveStatus: false,
            AgentCodes: self.reAgentCode,
            ShopCode: self.reSubAgentCode,
            RoleView: self.reViewPermissionCode
          })
          .then(function (response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reShopCodeOptions = [];
              data.forEach((element) => {
                self.reShopCodeOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
              callback(null, self.reShopCodeOptions);
            }
          })
          .catch(function (error) { });
      }
    }, 3000),
    resLoadreShopCodeOptions: function () {
      this.$refs.reShopCode.trigger.searchQuery = null;
    },
    LoadreShopTypeIdOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    // LoadreShopTypeIdOptions: function (e) {
    //   var self = this;
    //   axios
    //     .post("/Api/Report/Select2ShopAgentType", {
    //       page: 1,
    //       all: true,
    //       InActiveStatus: false,
    //       AgentCodes: self.reAgentCode,
    //       ShopCode: self.reSubAgentCode,
    //       RoleView: self.reViewPermissionCode
    //     })
    //     .then(function (response) {
    //       if (response.status == 200) {
    //         var data = response.data.results;
    //         self.reShopTypeIdOptions = [];
    //         data.forEach((element) => {
    //           self.reShopTypeIdOptions.push({
    //             id: element.id,
    //             label: element.text,
    //           });
    //         });
    //       }
    //     })
    //     .catch(function (error) { });
    // },
    LoadreSalesAreaIdOptions: function (e) {
      var self = this;
      axios
        .post("/Api/MasterSalesArea/Select2PaymentProduct", {
          page: 1,
          all: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reSalesAreaIdOptions = [];
            data.forEach((element) => {
              self.reSalesAreaIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreProvinceIdOptions: function (e) {
      var self = this;
      axios
        .post("/Api/Report/Select2PaymentProductProvince", {
          page: 1,
          all: true,
          salesAreaId: self.reSalesAreaId,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reProvinceIdOptions = [];
            data.forEach((element) => {
              self.reProvinceIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreTransitIdOptions() {
      var self = this;
      axios
        .post("/Api/Transport/Select2Transport", {
          showVendorTransport: false,
          agentCodes: [],
          isShowPickup: false,
          page: 1,
          search: null,
          isShowAll: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTransitIdOptions = [];
            data.forEach((element) => {
              self.reTransitIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreTransitTypeOptions() {
      var self = this;
      axios
        .post("/Api/Transport/Select2TransportType", {
          showVendorTransport: false,
          agentCodes: [],
          isShowPickup: false,
          page: 1,
          search: null,
          isShowAll: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reTransitTypeOptions = [];
            data.forEach((element) => {
              self.reTransitTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    reLoadreScanUserIdOptions: function(){
      this.$refs.reScanUserId.trigger.searchQuery = null;
    },
    LoadreScanUserIdOptions({ callback }) {
      var self = this;
      self.reScanUserIdOptions = [];
      if (self.isLoadingOptions) {
        axios
          .post("/Api/Report/Select2ScanUser", {
            page: 1,
            search: null,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reScanUserIdOptions = [];
              data.forEach((element) => {
                self.reScanUserIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
              self.isLoadingOptions = false;
            }
            callback(null, self.reScanUserIdOptions);
          });
      }
    },
    async LoadreViewPermissionOptions() {
      var self = this;
      await axios
        .get("/Api/Report/Select2ViewPermission", {})
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.reViewPermissionOptions = [];
            data.forEach((element) => {
              self.reViewPermissionOptions.push({
                id: element.id,
                label: element.text,
              });

              if (element.data == "active") {
                self.reViewPermissionCode = element.id;
              }
            });
          }
        })
        .catch(function (error) { });
    },
    async ChangeOptions(type) {
      var self = this;
      if (self.LoadFrist == false) {
        if (type == "View") {
          self.formResetValue();
          self.LoadrePlantCodeOptions();
          self.LoadreAgentCodeOptions();
          self.LoadreSubAgentCodeOptions();
          // self.LoadreShopCodeOptions();
          self.LoadreSalesAreaIdOptions();
          self.LoadreProvinceIdOptions();

          // var table = $("#PaymentProductTable");
          // await self.GenCollums(table);
          // self.GetDataTable(table);
          // self.LoadFrist = true;
        }
        else if (type == "reSalesAreaId") {
          self.LoadreProvinceIdOptions(); // จังหวัด
          self.LoadreAgentCodeOptions(); // ตัวแทนจำหน่าย
          self.LoadreSubAgentCodeOptions(); // ตัวแทนจำหน่ายย่อย
          // self.LoadreShopCodeOptions(); // ร้านค้า
        }
        else if (type == "reAgentCode") {
          // self.LoadreShopCodeOptions();
          //self.LoadreShopTypeIdOptions();
        }
        else if (type == "reSubAgentCode") {
          // self.LoadreShopCodeOptions();
        }
        else if (type == "reShopCode") {
          // self.LoadreShopCodeOptions();
        }
      }
    },
    GenCollums(table, action) {
      var self = this;
      self.columns = null;

      if (self.reViewPermissionCode == "AGENT_REPORT") {
        self.columns = [
          { data: "jobId", className: "text-center", visible: false, },
          { data: "jobId", className: "text-center", visible: false, },

          {
            data: "agentCode",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          // { data: "plantCode", className: "text-center" },
          // { data: "plantName", className: "text-center" },
          // { data: "caR_REG", className: "text-center" },
          // { data: "companY_NAME", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          { data: "jobNumber", className: "text-center" },
          { data: "cusT_CODE", className: "text-center" },
          { data: "shopName", className: "text-center" },
          { data: "shopName2", className: "text-center" },
          { data: "shopTypeName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "countBarcode", className: "text-center" },
          { data: "scanDateString", className: "text-center" },
          { data: "scanByUserName", className: "text-center" }
        ];
      }
      else if (self.reViewPermissionCode == "SUB_AGENT_REPORT") {
        self.columns = [
          {
            data: "agentCode",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          // { data: "plantCode", className: "text-center" },
          // { data: "plantName", className: "text-center" },
          // { data: "caR_REG", className: "text-center" },
          // { data: "companY_NAME", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },

          { data: "cusT_CODE", className: "text-center" },
          { data: "shopName", className: "text-center" },

          { data: "jobNumber", className: "text-center" },

          { data: "subAgentCode", className: "text-center" },
          { data: "subAgentName", className: "text-center" },
          { data: "subAgentName2", className: "text-center" },

          { data: "shopTypeName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "countBarcode", className: "text-center" },
          { data: "scanDateString", className: "text-center" },
          { data: "scanByUserName", className: "text-center" }
        ];
      }
      else {
        self.columns = [
          { data: "jobId", className: "text-center", visible: false, },
          { data: "jobId", className: "text-center", visible: false, },
          {
            data: "agentCode",
            className: "text-center",
            render: function (data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          { data: "plantCode", className: "text-center" },
          { data: "plantName", className: "text-center" },
          { data: "jobNumber", className: "text-center" },
          { data: "caR_REG", className: "text-center" },
          { data: "companY_NAME", className: "text-center" },
          { data: "agentCode", className: "text-center" },
          { data: "agentName", className: "text-center" },
          // { data: "cusT_CODE", className: "text-center" },
          // { data: "shopName", className: "text-center" },
          // { data: "shopTypeName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "productCode", className: "text-center" },
          { data: "productName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          { data: "barcodeNoOld", className: "text-center" },
          { data: "countBarcode", className: "text-center" },
          { data: "scanDateString", className: "text-center" },
          { data: "scanByUserName", className: "text-center" },
        ];
      }

      if (action == "submit") {
        table.clear();
        table.destroy();
        table = $("#PaymentProductTable");
        self.GetDataTable(table);
      }
    },
    GetDataTable(table) {
      var self = this;
      $.fn.dataTable.ext.errMode = 'none';
      table
        .DataTable({
          autoWidth: true,
          scrollY: "100%",
          scrollX: true,
          responsive: true,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          ajax: {
            url: "/Api/Report/PaymentProduct",
            type: "post",
            dataType: "json",
            contentType: "application/json",
            beforeSend: function (request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            },
            data: function (d) {
              let jsonSearch = {
                IsInitial: self.reIsInitial,

                StartDate:
                  self.reStartDate != null
                    ? self.reStartDate.format("DD/MM/YYYY")
                    : null,

                EndDate:
                  self.reEndDate != null
                    ? self.reEndDate.format("DD/MM/YYYY")
                    : null,

                Barcode: self.reBarcode,
                ProductTypeId: self.reProductTypeId,
                ProductCode: self.reProductCode,
                ProductBrandId: self.reProductBrandId,
                PlantCode: self.rePlantCode,
                AgentCode: self.reAgentCode,
                SubAgentCode: self.reSubAgentCode,
                ShopCode: self.reShopCode,
                ShopTypeId: self.reShopTypeId,
                Region: self.reSalesAreaId,
                ProvinceId: self.reProvinceId,
                TransitId: self.reTransitId,
                TransitType: self.reTransitType,
                ScanUserId: self.reScanUserId,
                ViewPermissionCode: self.reViewPermissionCode
              };
              return JSON.stringify($.extend(d, jsonSearch));
            },
          },
          // DOM Layout settings
          dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

          lengthMenu: [50, 100, 200, 500],

          pageLength: 100,

          language: {
            lengthMenu: "Display _MENU_",
            // Issue 2 (2026-06-15): ตัด "(filtered from X total entries)" ออก
            //   เนื่องจาก backend ไม่ทำ unfiltered COUNT แล้ว
            infoFiltered: "",
          },
          // Order settings
          order: self.reOrderBy = [[17, "desc"]],
          columns: self.columns,
          drawCallback: function (settings) {
            self.reIsInitial = false;
            self.reDateReq = moment().format("DD/MM/YYYY h:mm a");
            self.reTotalBarcode = 0;

            if (settings.json.data.length > 0) {
              var data = settings.json.data;
              data.forEach((element) => {
                self.reTotalBarcode = self.reTotalBarcode + element.countBarcode;
              });
            }

            // var allPage = table.DataTable().page.info().pages;
            // var currentPage = table.DataTable().page.info().page +1;

            // self.isShowFooter = false;
            // self.TotalAmount = 0;

            // if(allPage == currentPage){
            //   self.isShowFooter = true;
            //   self.TotalAmount = settings.json.data[0].totalAmount;
            // }
          },
        })
        .on("preXhr.dt", function () {
          KTApp.block(self.$refs.form, {
            showOverlay: false,
            opacity: 0.05,
            message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
          });
        })
        .on("xhr.dt", function () {
          KTApp.unblock(self.$refs.form);
        })
        .on("error.dt", function ( e, settings, techNote, message ) {
          DatatableWarning.alert(techNote);
        })
        .on("draw.dt", function () {
          // var t = table.DataTable();
          // var page = t.page.info().start + 1;
          // t.column(0, {}).nodes().each( function (cell, i) {
          //     cell.innerHTML = i+page;
          // } );
        });
    },
    ExportPaymentProduct: function (e) {
      e.preventDefault();
      let self = this;
      var IsValidate = true;
      self.errors = [];

      // if (!self.reSalesAreaId || self.reSalesAreaId == undefined || self.reSalesAreaId == null || self.reSalesAreaId.length == 0) {
      //   self.errors.push({ name: 'reSalesAreaId', text: 'กรุณาเลือกเขต' });
      //   IsValidate = false;
      // }

      // if (!self.reProvinceId || self.reProvinceId == undefined || self.reProvinceId == null || self.reProvinceId.length == 0) {
      //   self.errors.push({ name: 'reProvinceId', text: 'กรุณาเลือกจังหวัด' });
      //   IsValidate = false;
      // }

      if (!self.reStartDate || self.reStartDate == undefined || self.reStartDate == null) {
        self.errors.push({ name: 'reStartDate', text: 'กรุณาเลือกวันที่เริ่มต้น' });
        IsValidate = false;
      }

      if (!self.reEndDate || self.reEndDate == undefined || self.reEndDate == null) {
        self.errors.push({ name: 'reEndDate', text: 'กรุณาเลือกวันที่สิ้นสุด' });
        IsValidate = false;
      }

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      if (IsValidate == true) {
        KTApp.blockPage({
          opacity: 0.05,
          message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
        });

        axios({
          method: "post",
          url: "/Api/Report/ExportPaymentProduct",
          responseType: "arraybuffer",
          data: {
            StartDate:
              self.reStartDate != null
                ? self.reStartDate.format("DD/MM/YYYY")
                : null,

            EndDate:
              self.reEndDate != null
                ? self.reEndDate.format("DD/MM/YYYY")
                : null,

            Barcode: self.reBarcode,
            ProductTypeId: self.reProductTypeId,
            ProductCode: self.reProductCode,
            ProductBrandId: self.reProductBrandId,
            PlantCode: self.rePlantCode,
            AgentCode: self.reAgentCode,
            SubAgentCode: self.reSubAgentCode,
            ShopCode: self.reShopCode,
            ShopTypeId: self.reShopTypeId,
            Region: self.reSalesAreaId,
            ProvinceId: self.reProvinceId,
            TransitId: self.reTransitId,
            TransitType: self.reTransitType,
            ScanUserId: self.reScanUserId,
            ViewPermissionCode: self.reViewPermissionCode,
            // OrderByCollum: self.reOrderBy != null ? this.OrderName(self.reOrderBy[0][0]) : null,
            // OrderBy: self.reOrderBy != null ? self.reOrderBy[0][1] : null
          },
        })
          .then(function (response) {
            if (response.status == "200") {
              let filename = "";
              let contentType = response.headers["content-type"];
              let disposition = response.headers["content-disposition"];

              //===Get Filename===
              if (disposition && disposition.indexOf("attachment") !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, "");
                }
              }

              //Save file
              let blob = new Blob([response.data], { type: contentType });
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob);
              link.download = decodeURIComponent(filename);
              link.click();
            } else if (response.status == "204") {
              Swal.fire(
                "ไม่พบข้อมูล",
                "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
                "warning"
              );
            }
          })
          .catch(function (error) {
            // Issue 2 (2026-06-12): responseType=arraybuffer → error.response.data
            //   เป็น ArrayBuffer (ไม่ใช่ JSON object) → ต้อง decode + parse ก่อน
            //   ใช้สำหรับแสดง message จาก row-count guard (BadRequest)
            var msg = "เกิดข้อผิดพลาดขณะ Export";
            try {
              var raw = error && error.response && error.response.data;
              if (raw instanceof ArrayBuffer) {
                var text = new TextDecoder("utf-8").decode(new Uint8Array(raw));
                try {
                  var parsed = JSON.parse(text);
                  msg = parsed.Message || parsed.message || text || msg;
                } catch (e) {
                  msg = text || msg;
                }
              } else if (raw && (raw.Message || raw.message)) {
                msg = raw.Message || raw.message;
              }
            } catch (e) { /* fallback to default msg */ }
            Swal.fire("เกิดข้อผิดพลาด", msg, "error");
          })
          .then(function () {
            //self.formReset();
            KTApp.unblockPage();
          });
      }
    },
    ClearAfterselect: function () {
      $(`[class="vue-treeselect__input"]`).val("");
    }
  },
  async mounted() {
    let self = this;

    await self.LoadreViewPermissionOptions();
    self.LoadrePlantCodeOptions();
    self.LoadreProductTypeIdOptions();
    self.LoadreProductCodeOptions();
    self.LoadreProductBrandIdOptions();
    self.LoadreAgentCodeOptions();
    self.LoadreSubAgentCodeOptions();
    // self.LoadreShopCodeOptions();
    self.LoadreShopTypeIdOptions();
    self.LoadreSalesAreaIdOptions();
    self.LoadreProvinceIdOptions();
    self.LoadreTransitIdOptions();
    self.LoadreTransitTypeOptions();
    // self.LoadreScanUserIdOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function (e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function (e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    var table = $("#PaymentProductTable");
    await self.GenCollums(table);
    self.GetDataTable(table);
    self.LoadFrist = false;

    // set validation rules
    $(this.$refs.form).validate({
      // rules: {
      //   // reSalesAreaId: "required",
      //   // reProvinceId: "required",
      //   reStartDate: "required",
      //   reEndDate: "required",
      // },
      // messages: {
      //   // reSalesAreaId: "กรุณาเลือกเขต",
      //   // reProvinceId: "กรุณาเลือกจังหวัด",
      //   reStartDate: "กรุณาเลือกวันที่เริ่มต้น",
      //   reEndDate: "กรุณาเลือกวันที่สิ้นสุด",
      // },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Report/PaymentProduct.vue